<template>
  <div>
    <el-tabs
      v-model="activeName"
      style="margin: 1em 0"
      @tab-click="handleClick"
    >
      <el-tab-pane label="使用说明" name="info"
        ><div v-html="js.info" class="tui-editor-contents"></div
      ></el-tab-pane>
      <el-tab-pane label="源代码" name="code" v-loading="loading">
        <highlightjs
          language="javascript"
          :code="code"
          style="
            height: 60em;
            overflow: auto;
            background-color: rgb(40, 44, 52);
          "
        />
      </el-tab-pane>
      <el-tab-pane label="问题反馈" name="bug" lazy>
        <ReportList :scriptId="js.id" />
      </el-tab-pane>
      <el-tab-pane label="举报脚本" name="report">举报</el-tab-pane>
      <el-tab-pane label="历史版本" name="hist">历史版本</el-tab-pane>
      <el-tab-pane label="统计数据" name="statistics" lazy>
        <Statistics :scriptId="js.id" />
      </el-tab-pane>
      <el-tab-pane
        label="更新脚本"
        name="update"
        v-if="js.owner"
        v-loading="loading"
      >
        <el-row style="height: 12em; width: max-content"></el-row>
      </el-tab-pane>
      <el-tab-pane label="删除脚本" name="delete" v-if="js.owner">
        <el-dialog
          title="确定删除吗？"
          :visible.sync="deletevisible"
          v-loading="deleteloading"
          width="32em"
        >
          <span>删除脚本后将不可恢复！</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="deletevisible = false">取 消</el-button>
            <el-button type="primary" @click="deleteJs">确 定</el-button>
          </span>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import "highlight.js/styles/atom-one-dark.css";

import ReportList from "./Report/ReportList";
import Statistics from "./Statistics";

import utils from "../utils";

export default {
  name: "ScriptInteractions",
  components: {
    ReportList,
    Statistics,
  },
  props: {
    index: Number,
    js: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      deletevisible: false,
      store: utils.store,
      utils,
      loading: false,
      deleteloading: false,
      activeName: "info",
      lastactiveName: "info",
      code: "",
    };
  },
  mounted() {},
  watch: {
    activeName: function(newval, oldval) {
      this.lastactiveName = oldval;
    },
  },
  methods: {
    deleteJs() {
      this.deleteloading = true;
      window.setTimeout(() => {
        this.deletevisible = false;
        this.deleteloading = false;
        this.$alert("暂不支持删除功能", "开发中...", {
          type: "error",
          confirmButtonText: "确定",
        });
      }, 1e3);
    },
    getCode() {
      this.loading = true;
      if (this.js && this.js.downloadUrl && !this.code) {
        return this.axios
          .get(`/api/getScriptDataById/${this.js.id}`)
          .then((res) => {
            this.loading = false;
            this.code = res.data;
            return this.code;
          });
      } else {
        this.loading = false;
        return Promise.resolve(this.code);
      }
    },
    handleClick(tab) {
      switch (tab.name) {
        case "code":
          this.getCode(this.axios);
          break;
        case "update":
          this.getCode().then((code) => {
            this.store.upsertVisible = true;
            this.store.js = { code, ...this.js };
            this.activeName = this.lastactiveName;
          });
          break;
        case "delete":
          this.activeName = this.lastactiveName;
          this.deletevisible = true;
          break;
      }
    },
  },

  computed: {},
};
</script>

<style lang="css">
.hljs {
  overflow-x: visible !important;
}
</style>
